var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UrlHashChangeHandler = /** @class */ (function () {
        function UrlHashChangeHandler() {
            this.contentIdHandlers = [];
            this.enableHashChangeOnUnfold = false;
        }
        UrlHashChangeHandler.prototype.addContentIdHandler = function (handler) {
            this.contentIdHandlers.push(handler);
        };
        UrlHashChangeHandler.prototype.getHash = function () {
            return location.hash;
        };
        UrlHashChangeHandler.prototype.init = function (handleInitialHash) {
            var _this = this;
            window.addEventListener('hashchange', function () { return _this.handleHashChange(); }, false);
            if (handleInitialHash) {
                this.handleHashChange();
            }
            this.initHashChangeOnUnfold();
        };
        UrlHashChangeHandler.prototype.handleHashChange = function () {
            this.enableHashChangeOnUnfold = false;
            this.handleHashChangeProcessor();
            this.enableHashChangeOnUnfold = true;
        };
        UrlHashChangeHandler.prototype.handleHashChangeProcessor = function () {
            var e_1, _a;
            var hash = this.getHash();
            if (!hash) {
                return;
            }
            if (hash === '#unfold-all') {
                $('.accordion .collapse').collapse('show');
                return;
            }
            if (/^#(c\d+)$/.test(hash)) {
                try {
                    for (var _b = __values(this.contentIdHandlers), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var handler = _c.value;
                        handler();
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                this.scrollToElement(hash);
                return;
            }
        };
        UrlHashChangeHandler.prototype.initHashChangeOnUnfold = function () {
            var _this = this;
            var body = $('body');
            body.on('show.bs.collapse', function (event) {
                if (!_this.enableHashChangeOnUnfold) {
                    return;
                }
                var clickedElement = $(event.target);
                var clickedFoldable = clickedElement.parent();
                if (!clickedFoldable.hasClass('card-foldable') ||
                    !clickedFoldable.parent().hasClass('accordion')) {
                    return;
                }
                // The card carries the content element id, the collapse inside it does not -
                // sharing the collapse would scroll a reader past the question to the answer.
                var foldableId = clickedFoldable.attr('id');
                if (!foldableId) {
                    return;
                }
                history.replaceState(undefined, undefined, '#' + foldableId);
            });
            body.on('show.bs.tab', function (event) {
                if (!_this.enableHashChangeOnUnfold) {
                    return;
                }
                var clickedElement = $(event.target);
                history.replaceState(undefined, undefined, clickedElement.attr('href'));
            });
        };
        /**
         * Safari drops a smooth scroll that collides with its own scheduled fragment
         * scrolling (webkit.org/b/239605, fixed for focus but not for fragments), so the
         * landing is checked once and jumped to if the scroll did not take.
         */
        UrlHashChangeHandler.prototype.scrollTo = function (element) {
            var settled = false;
            var inputEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];
            var release = function () {
                settled = true;
                inputEvents.forEach(function (eventName) {
                    return window.removeEventListener(eventName, release);
                });
                window.removeEventListener('scrollend', verify);
            };
            var verify = function () {
                if (settled) {
                    return;
                }
                var expected = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-top')) || 0;
                var landed = element.getBoundingClientRect().top;
                release();
                if (Math.abs(landed - expected) > 1) {
                    element.scrollIntoView({ block: 'start' });
                }
            };
            inputEvents.forEach(function (eventName) {
                return window.addEventListener(eventName, release, { passive: true });
            });
            // A dropped scroll fires no scrollend, hence the timeout too.
            window.addEventListener('scrollend', verify);
            window.setTimeout(verify, UrlHashChangeHandler.SCROLL_VERIFY_MS);
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        };
        UrlHashChangeHandler.prototype.scrollToElement = function (idSelector) {
            var _this = this;
            var element = document.querySelector(idSelector);
            if (!element) {
                return;
            }
            this.whenExpansionFinished(function () { return _this.scrollTo(element); });
        };
        /** Measuring before the foldable or tab has expanded reads a stale position. */
        UrlHashChangeHandler.prototype.whenExpansionFinished = function (callback) {
            var startTime = performance.now();
            var check = function () {
                // Bootstrap marks both for the length of the transition.
                var expanding = document.querySelector('.collapsing, .tab-pane.active:not(.show)');
                if (!expanding ||
                    performance.now() - startTime >
                        UrlHashChangeHandler.EXPANSION_TIMEOUT_MS) {
                    callback();
                    return;
                }
                window.requestAnimationFrame(check);
            };
            check();
        };
        UrlHashChangeHandler.EXPANSION_TIMEOUT_MS = 1000;
        UrlHashChangeHandler.SCROLL_VERIFY_MS = 1000;
        return UrlHashChangeHandler;
    }());
    exports.default = UrlHashChangeHandler;
});
